import { DocumentSnapshot } from '@google-cloud/firestore';
import { flow, getRoot, Instance, types } from 'mobx-state-tree';

import firebaseService from './../services/firebaseService';
import UserModel, { IUserModel } from './models/UserModel';
import { IRootStore } from './RootStore';

const UserStore = types
    .model('UserStore', {
        list: types.map(UserModel),
    })
    .actions(self => {
        const rootStore: IRootStore = getRoot(self);
        const addUser = (user: IUserModel) => {
            self.list.set(user.id, user);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return self.list.get(user.id)!;
        };

        const addUserGuestToDB = flow(function* addUserGuestToDB(user: IUserModel) {
            yield firebaseService.storeUserGuest(rootStore.config.uid, user);
        }) as (user: IUserModel) => Promise<void>;

        const loadUsersFromDB = flow(function* loadDataFromDB() {
            const usersDoc: DocumentSnapshot<IUsersDocument> = yield firebaseService.loadUsers(rootStore.config.uid);
            const users = usersDoc.data();

            if (users) {
                users.guests.forEach(user => {
                    self.list.set(user.id, user);
                });
            }
        }) as () => Promise<void>;

        return { addUser, loadUsersFromDB, addUserGuestToDB };
    });

export interface IUserStore extends Instance<typeof UserStore> {}

export interface IUsersDocument {
    guests: IUserModel[];
}

export default UserStore;
